import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import MyYuukke from "../../api/MyYuukke";
import { API_URL, BASE_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import calendar from "../../img/calendar.png";

import { Rating } from "@material-ui/lab";
import ReCAPTCHA from "react-google-recaptcha";
import { serviceIcons, themesPallates, neutralDefaultTheme, hexToRgba } from "../../components/Utils";
import "./servicedashbaord.css";
import "./servicedashboard-responsive.css"
import "./bookingUiStyles.css";
import { MdOutlinePhoto, MdOutlineFileDownload } from "react-icons/md";
import { GrAnnounce } from "react-icons/gr";
import { BsCameraVideo } from "react-icons/bs";
import { MdOutlineReviews } from "react-icons/md";
import { FiFileText, FiDownload, FiChevronRight } from "react-icons/fi";
import PhoneInput from "react-phone-input-2";

moment.locale("en");

/* ─────────────────────────────────────────────
   MonthGridCalendar (UNCHANGED)
───────────────────────────────────────────── */
function MonthGridCalendar({ slots, packageDays, selectedValue, hoverCol, onSelect }) {
  const today = moment().locale("en");
  const [viewMonth, setViewMonth] = useState(today.clone().startOf("month"));
  const [animKey, setAnimKey] = useState(0);

  const availableSet = new Set((slots || []).filter(s => s.available).map(s => s.value));
  const slotMap = {};
  (slots || []).forEach(s => { slotMap[s.value] = s; });

  const goMonth = (dir) => {
    setViewMonth(prev => prev.clone().locale("en").add(dir, "month").startOf("month"));
    setAnimKey(k => k + 1);
  };

  const vmEn = viewMonth.clone().locale("en");
  const startDay = vmEn.clone().startOf("month").day();
  const daysInMonth = vmEn.daysInMonth();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const isPrevDisabled = viewMonth.clone().locale("en").isSameOrBefore(today.clone().startOf("month"));

  return (
    <div>
      <div className="monthNavRow">
        <button className="monthNavBtn" onClick={() => goMonth(-1)} disabled={isPrevDisabled}>‹</button>
        <h4>{vmEn.format("MMMM YYYY")}</h4>
        <button className="monthNavBtn" onClick={() => goMonth(1)}>›</button>
      </div>
      <table className="monthGridCalendar" key={animKey}>
        <thead>
          <tr>{DOW.map(d => <th key={d}>{d}</th>)}</tr>
        </thead>
        <tbody className="monthGridAnim">
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                if (!day) return <td key={di}><button className="gridDayBtn emptyDay">0</button></td>;
                const dateVal = vmEn.clone().date(day).format("YYYY/MM/DD");
                const isPast = vmEn.clone().date(day).isBefore(today, "day");
                const isToday = vmEn.clone().date(day).isSame(today, "day");
                const dayMatches = packageDays.length === 0 ||
                  packageDays.includes(moment(dateVal, "YYYY/MM/DD").locale("en").format("ddd").toUpperCase());
                const isAvail = availableSet.has(dateVal) && !isPast && dayMatches;
                const isSelected = selectedValue === dateVal;
                const btnClass = [
                  "gridDayBtn",
                  isSelected ? "gridSelected" : "",
                  isToday && !isSelected ? "gridToday" : "",
                  isAvail && !isSelected ? "gridAvailable" : "",
                  !isAvail && !isSelected ? "gridDisabled" : "",
                ].filter(Boolean).join(" ");
                return (
                  <td key={di}>
                    <button
                      className={btnClass}
                      onClick={() => {
                        if (!isAvail) return;
                        const slotObj = slotMap[dateVal];
                        if (slotObj) onSelect(slotObj);
                      }}
                    >
                      {day}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* ─────────────────────────────────────────────
   TimeSidePanel — used by Group Package (UNCHANGED)
───────────────────────────────────────────── */
function TimeSidePanel({ hasDateSelected, slots, selectedSlot, hoverCol, onSelect, isDisabledFn }) {
  return (
    <div className="timeSide">
      <div className="panelLabel">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
        </svg>
        Select Time
      </div>
      {!hasDateSelected ? (
        <div className="calEmptyState">
          <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#c4c9d8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
          </svg>
          <p>
            <strong>No date selected</strong>
            Pick a date on the left to see available time slots
          </p>
        </div>
      ) : (
        <div className="timeSlotGrid slotPanel">
          {slots.length > 0 ? slots.map((item, i) => {
            const fromStr = item.from ?? "";
            const toStr = item.to ?? "";
            const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
            const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
            const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
            const isSelected = selectedSlot?.from === fromStr && selectedSlot?.to === toStr;
            const isDisabled = isDisabledFn ? isDisabledFn(item) : false;
            return (
              <button
                key={i}
                className={`timeSlotBtn${isSelected ? " tsActive" : ""}${isDisabled ? " tsDisabled" : ""}`}
                style={isSelected ? { background: hoverCol } : {}}
                onClick={() => { if (!isDisabled) onSelect(item); }}
              >
                {displayFrom} – {displayTo}
              </button>
            );
          }) : (
            <p className="noTimeMsg">No slots available for this date</p>
          )}
        </div>
      )}
    </div>
  );
}

// Add near the top of the component, alongside other helpers
const getThemeItem = (iconId) => {
  const idx = typeof iconId === "number" && iconId >= 0 && iconId < themesPallates.length ? iconId : 0;
  return themesPallates[idx] || { primary: "#a00030", accent: "#a00030" };
};

/* ═══════════════════════════════════════════════════════════
   Main component
═══════════════════════════════════════════════════════════ */
const ServiceCardThemeV2 = ({
  data,
  selectService,
  userUpcomingMeting,
  isPreview,
  onSendMsgClick,
  uploadDetails,
  updateState,
  confirmDetails,
  recaptcha,
  viewAvailableSlot,
  slugSelected,
  handleOpenReviews,
  // ── NEW: resource purchase flow ─────────────────────────────────────────
  // Same contract as ServiceCardThemeV3's onResourceClick(resource) — parent
  // (CalendarVcard) decides free → redirect vs paid → open RazorPay. This
  // component just renders the cards and forwards the click.
  onResourceClick,
}) => {

  const businessLogo = isPreview
    ? data.eventDetails?.businessLogo
    : data.eventDetails?.businessLogo
      ? `${API_URL}auth/image/${data.eventDetails?.businessLogo}`
      : calendar;

  const serviceListPage = useRef();

  const [state, setState] = useState({
    serviceGalleryImage: [],
    serviceProviderVideo: [],
    serviceAnnouncement: [],
    cancelMeetingModel: false,
    bookingDetails: null,
    loader: false,
  });

  const [chosenRes, setChosenRes] = useState({ type: "", url: "" });
  const [showResModal, setShowResModal] = useState(false);
  const isMobile = window.screen.width < 768;

  const [chosenService, setChosenService] = useState(null);
  const [focusTab, setFocusTab] = useState(0);
  const [isPackageSelected, setIsPackageSelected] = useState({});
  const scheduleRef = useRef(null);

  // ── bookingMode and expertNote come from parent state (data.bookingMode / data.expertNote)
  // ── Do NOT use local state for these — it causes the toggle/calendar sync bug

  const hoverCol = getComputedStyle(document.documentElement).getPropertyValue("--primary").trim() || "#a00030";

  const resTabList = [
    { title: "Announcements", id: 0, key: "serviceAnnouncement", icon: <GrAnnounce /> },
    { title: "Photos", id: 1, key: "serviceGalleryImage", icon: <MdOutlinePhoto /> },
    { title: "Videos", id: 2, key: "serviceProviderVideo", icon: <BsCameraVideo /> },
    { title: "Reviews", id: 3, key: "reviewList", icon: <MdOutlineReviews /> },
  ];

  /* ── NEW (additive, presentational only): section refs + scrollspy ── */
  const heroSectionRef = useRef(null);
  const servicesSectionRef = useRef(null);
  const resourcesSectionRef = useRef(null);
  const bookSectionRef = useRef(null);
  const proofSectionRef = useRef(null);
  const footerSectionRef = useRef(null);
  const servicesTrackRef = useRef(null);
  const galleryTrackRef = useRef(null);

  const [activeNav, setActiveNav] = useState("profile");
  const [servicesScrollPct, setServicesScrollPct] = useState(0);
  const [galleryScrollPct, setGalleryScrollPct] = useState(0);
  const [videoPlaying, setVideoPlaying] = useState(false);

  // Order matches the new visual order of the page: hero -> proof -> services -> book -> contact
  const railItems = [
    { key: "profile", label: "Profile", ref: heroSectionRef },
    { key: "proof", label: "Proof of work", ref: proofSectionRef },
    { key: "services", label: "Services", ref: servicesSectionRef },
    { key: "book", label: "Book a session", ref: bookSectionRef },
    { key: "contact", label: "Contact", ref: footerSectionRef },
  ];

  const scrollToRef = (ref) => ref?.current?.scrollIntoView({ behavior: "smooth" });

  useEffect(() => {
    const sections = railItems.map(r => r.ref.current).filter(Boolean);
    if (!sections.length || !("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const match = railItems.find(r => r.ref.current === entry.target);
            if (match) setActiveNav(match.key);
          }
        });
      },
      { rootMargin: "-40% 0px -50% 0px", threshold: 0 }
    );
    sections.forEach(s => io.observe(s));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const trackScroll = (ref, setter) => () => {
    const el = ref.current;
    if (!el) return;
    const maxScroll = el.scrollWidth - el.clientWidth;
    setter(maxScroll <= 0 ? 100 : Math.min(100, Math.round((el.scrollLeft / maxScroll) * 100)));
  };

  // ── Meta tags ──
  useEffect(() => {
    const setMeta = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) { tag = document.createElement("meta"); tag.setAttribute("name", name); document.head.appendChild(tag); }
      tag.setAttribute("content", content);
    };
    if (data?.userDetails?.userName || data?.eventDetails?.businessName)
      setMeta("yuukkeServicedescription", `Profile of ${data?.userDetails?.userName || data?.eventDetails?.businessName}, offering amazing services.`);
    if (data?.eventDetails?.slug)
      setMeta("yuukkeServiceUrl", `${BASE_URL}yuukke-service/${data?.eventDetails?.slug}`);
  }, []);

  // ── Custom theme ──
  // Sets the SAME shared CSS variable names ServiceCardThemeV3 sets, so
  // whichever of the two card components is mounted, the palette (bg,
  // font colors, borders, tag tones) stays visually consistent app-wide.
  // Previously this bailed out entirely when customTheme was off, which
  // left stale colors from a prior theme applied. It also mapped
  // --primaryHover to themeItem.thinBorder (a border tint, not a hover
  // shade) — fixed below to use themeItem.primaryHover instead.
  useEffect(() => {
    const rootStyle = document.documentElement.style;
    const themeItem = data.eventDetails?.customTheme
      ? themesPallates.find(item => item.id === data.eventDetails.themeId)
      : null;
    const theme = themeItem || neutralDefaultTheme;

    rootStyle.setProperty("--primary", theme.primary);
    rootStyle.setProperty("--primaryColor", theme.primary);
    rootStyle.setProperty("--primaryHover", theme.primaryHover);
    rootStyle.setProperty("--accent", theme.accent);
    rootStyle.setProperty("--background", theme.background);
    rootStyle.setProperty("--card", theme.card);
    rootStyle.setProperty("--card-foreground", theme.cardForeground);
    rootStyle.setProperty("--cardHover", theme.cardHover);
    rootStyle.setProperty("--border", theme.border);
    rootStyle.setProperty("--thinBorder", theme.thinBorder);
    rootStyle.setProperty("--thinBg", theme.thinBg);
    rootStyle.setProperty("--indiDot", theme.indiDot);
    rootStyle.setProperty("--headingColor", theme.heading);
    rootStyle.setProperty("--subHeadingColor", theme.subHeading);
    rootStyle.setProperty("--secondaryColor", theme.secondary);
    rootStyle.setProperty("--desText", theme.desText);
    rootStyle.setProperty("--tagtxtCol", theme.tagtxtCol);
    rootStyle.setProperty("--firstTagBg", theme.firstTagBg);
    rootStyle.setProperty("--secTagBg", theme.secTagBg);
    rootStyle.setProperty("--ThirdTagBg", theme.thirdTagBg);
    rootStyle.setProperty("--gradeStart", theme.lightGradeStart);
    rootStyle.setProperty("--gradeEnd", theme.lightGradeEnd);
    rootStyle.setProperty("--shadow", `0 10px 30px -12px ${hexToRgba(theme.primary, 0.24)}`);
  }, [data]);

  // ── Scroll on service select ──
  useEffect(() => {
    if (chosenService !== null)
      setTimeout(() => scheduleRef.current?.scrollIntoView({ behavior: "smooth" }), 0);
  }, [chosenService]);

  // ── Assets ──
  useEffect(() => {
    if (isPreview) {
      const arr = new Array(5).fill(10).map((_, i) => {
        const dt = moment(new Date()).locale("en").add("day", i);
        return { day: dt.format("ddd"), date: dt.format("MMM DD"), available: true, value: dt.format("YYYY/MM/DD") };
      });
      data.slots = arr;
      setState(prev => ({ ...prev, serviceProviderVideo: data.serviceProviderVideo, serviceAnnouncement: data.serviceAnnouncement, serviceGalleryImage: data.serviceGalleryImage }));
    } else {
      let serviceProviderVideo = [], serviceAnnouncement = [], serviceGalleryImage = [];
      if (data.eventDetails.serviceProviderVideo) serviceProviderVideo = data.eventDetails.serviceProviderVideo.split(",");
      if (data.eventDetails.serviceAnnouncement) serviceAnnouncement = data.eventDetails.serviceAnnouncement.split(",").map(item => `${API_URL}auth/image/${item}`);
      if (data.eventDetails.serviceGalleryImage) serviceGalleryImage = data.eventDetails.serviceGalleryImage.split(",").map(item => `${API_URL}auth/image/${item}`);
      setState(prev => ({ ...prev, serviceProviderVideo, serviceAnnouncement, serviceGalleryImage }));
    }
  }, [data]);

  // ── Slug auto-select ──
  useEffect(() => {
    if (!slugSelected || !data?.serviceList?.length) return;
    const index = data.serviceList.findIndex(s => s.slug === slugSelected || s.id === slugSelected || String(s.id) === String(slugSelected));
    if (index !== -1) {
      const item = data.serviceList[index];
      setChosenService(index);
      setIsPackageSelected(item);
      selectService(item);
      setTimeout(() => scheduleRef?.current?.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, [slugSelected, data.serviceList]);

  // ── Helpers ──
  const safeParse = (value) => {
    try { if (!value) return []; const p = JSON.parse(value); return typeof p === "string" ? JSON.parse(p) : p; }
    catch (e) { return []; }
  };

  const packageDays = safeParse(isPackageSelected?.packageDays);
  const timeSlots = safeParse(isPackageSelected?.timeSlots) || [];

  const getAllSlots = () => {
    if (!data.availableSlot?.length) return [];
    return data.availableSlot.filter(item => {
      if (Object.keys(data?.activeIndexData || {}).length > 0) {
        const isToday = moment(data.activeIndexData.value, "YYYY/MM/DD");
        if (isToday.isSame(moment(), "day")) {
          const curTime = moment(new Date(), "HH:mm");
          const fromTime = moment(item.from, "HH:mm");
          return fromTime.isSameOrAfter(curTime);
        }
      }
      return true;
    });
  };

  const calIconSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 2v4" /><path d="M16 2v4" /><rect width="18" height="18" x="3" y="4" rx="2" /><path d="M3 10h18" />
    </svg>
  );

  // ── Stepper helper (UNCHANGED) ──
  const renderStepper = (activeStep) => (
    <div className="bkStepBar">
      <div className={`bkStep ${activeStep === 1 ? "active" : activeStep > 1 ? "done" : ""}`}>
        <div className="bkStepCircle">{activeStep > 1 ? "✓" : "1"}</div>
        <span>Choose option</span>
      </div>
      <div className={`bkStepLine ${activeStep > 1 ? "done" : ""}`} />
      <div className={`bkStep ${activeStep === 2 ? "active" : activeStep > 2 ? "done" : ""}`}>
        <div className="bkStepCircle">{activeStep > 2 ? "✓" : "2"}</div>
        <span>Provide details</span>
      </div>
      <div className={`bkStepLine ${activeStep > 2 ? "done" : ""}`} />
      <div className={`bkStep ${activeStep === 3 ? "active" : ""}`}>
        <div className="bkStepCircle">3</div>
        <span>Confirmation</span>
      </div>
    </div>
  );

  // ── Purely presentational derived values for the new layout ──
  const priceLabel = (svc) => (svc?.amount == 0 ? "Free" : `₹${svc?.amount}`);
  const selectedServiceObj = data.serviceList?.[chosenService];

  const tickerMessages = [
    data.eventDetails?.ratings ? `★ ${data.eventDetails.ratings} average rating` : null,
    data.eventDetails?.noOfClients ? `${data.eventDetails.noOfClients}+ clients served` : null,
    data.bookingCount > 9 ? `${data.bookingCount}+ bookings completed` : null,
    data.eventDetails?.serviceName ? `Now booking · ${data.eventDetails.serviceName}` : null,
  ].filter(Boolean);

  const activeProofList = state?.[resTabList[focusTab]?.key] || [];

  // ── Derived values for the new "forest" proof-of-work layout ──
  const galleryPool = state.serviceGalleryImage?.length ? state.serviceGalleryImage : state.serviceAnnouncement;
  const powCollageMain = galleryPool?.[0] || businessLogo;
  const powCollageThumbs = (galleryPool?.length > 1 ? galleryPool.slice(1, 3) : []);
  const powFeaturedReview = data.reviewList?.[0] || null;
  const powInitials = (name) => (name ? name.trim().split(/\s+/).slice(0, 2).map(w => w[0]?.toUpperCase()).join("") : "?");
  const powHighlightImage = activeProofList?.[0] || null;

  // ── Resources — direct-buy items, no calendar/slot flow. Rendered the
  // same visual language as the service cards above (sp-service-card),
  // just with a "Resource" tag and a file-count line instead of duration.
  // Free (amount 0) → onResourceClick redirects immediately.
  // Paid (amount > 0) → onResourceClick opens RazorPay directly.
  const resourceList = data.resourceList || [];

  const handleResourceCardClick = (res) => {
    if (isPreview) return;
    if (typeof onResourceClick === "function") onResourceClick(res);
  };

  return (
    <div className="servicePageContainer sp-page">

      {/* ── Mobile bottom bar ── */}
      <div className="sp-mobile-bar">
        <a className="sp-m-msg" onClick={onSendMsgClick}>✉ Message</a>
        <a className="sp-m-book" onClick={() => scrollToRef(servicesSectionRef)}>Book a session</a>
      </div>

      {/* ── Side rail nav ── */}
      <nav className="sp-rail">
        {railItems.map(item => (
          <a
            key={item.key}
            className={activeNav === item.key ? "sp-active" : ""}
            onClick={() => scrollToRef(item.ref)}
          >
            <span className="sp-dot"></span>
            <span className="sp-label">{item.label}</span>
          </a>
        ))}
      </nav>

      {/* ── Header ── */}
      <header className="sp-header-top">
        <div className="sp-brand">
          <span className="sp-mark"><img src={businessLogo} alt="logo" /></span>
          {data.eventDetails?.serviceName || data.userDetails?.userName || "My Business"}
        </div>
        <button type="button" className="sp-top-cta" onClick={() => scrollToRef(servicesSectionRef)}>
          Book a session →
        </button>
      </header>

      {/* ── Hero ── */}
      <section className="sp-hero" ref={heroSectionRef} id="profile">
        <div className="sp-wrap sp-hero-grid">
          <div className="sp-hero-body">
            {(data?.userDetails?.userName || data?.eventDetails?.serviceName) && (
              <span className="sp-eyebrow">
                {data?.eventDetails?.serviceName || "Verified Professional"}
                {data?.userDetails?.userName ? ` · ${data.userDetails.userName}` : ""}
              </span>
            )}
            <h1 className="sp-headline heroHeading">{data?.sliderText?.[0] || ""}</h1>
            <p className="sp-sub heroSubHeading">{data?.sliderText?.[1] || ""}</p>
            <div className="sp-hero-ctas">
              <button type="button" className="sp-btn sp-btn-primary" onClick={() => scrollToRef(servicesSectionRef)}>
                Book a session
              </button>
              <button type="button" className="sp-btn sp-btn-ghost" onClick={() => scrollToRef(proofSectionRef)}>
                See the proof
              </button>
            </div>
            <div className="sp-stat-row">
              <div className="sp-stat">★ <b>{data.eventDetails?.ratings ?? "4.1"}</b>&nbsp;average rating</div>
              <div className="sp-stat"><b>{data.eventDetails?.noOfClients || 0}+</b>&nbsp;clients advised</div>
              {data.bookingCount > 9 && (
                <div className="sp-stat"><b>{data.bookingCount}+</b>&nbsp;bookings</div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ── Announcement ticker (derived from real profile stats) ── */}
      {tickerMessages.length > 0 && (
        <div className="sp-ticker-wrap">
          <div className="sp-ticker">
            {[...tickerMessages, ...tickerMessages].map((msg, i) => (
              <span key={i}>{msg}</span>
            ))}
          </div>
        </div>
      )}

      {/* ── Proof of work (Announcements / Photos / Video / Reviews) ── */}
      <section className="pow-section" ref={proofSectionRef} id="proof">

        <div className="pow-wrap">
          {/* Left: photo collage + floating testimonial */}
          <div className="pow-visual">
            <div className="pow-img-main">
              <img src={powCollageMain} alt="Work in progress" loading="lazy" />
            </div>
            {powCollageThumbs.length > 0 && (
              <div className="pow-img-stack">
                {powCollageThumbs.map((img, i) => (
                  <img key={i} src={img} alt={`Highlight ${i + 1}`} loading="lazy" />
                ))}
              </div>
            )}
            {powFeaturedReview && (
              <div className="pow-quote-card">
                <div className="pow-quote-dots"><span /><span /><span /></div>
                <p className="pow-quote-text">"{powFeaturedReview.suggestion}"</p>
                <div className="pow-quote-who">
                  <div className="pow-quote-avatar">{powInitials(powFeaturedReview.name)}</div>
                  <div>
                    <div className="pow-quote-name">{powFeaturedReview.name}</div>
                    <div className="pow-quote-role">Client</div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Right: kicker, heading, tabs, highlight card, CTA */}
          <div className="pow-content">
            <span className="pow-kicker">PROOF OF WORK</span>
            <h2 className="pow-heading">See the work,<br />hear from clients</h2>
            <p className="pow-desc">
              A gallery of impact. From strategic frameworks to transformative sessions, explore how we move the needle.
            </p>

            <div className="pow-tabs">
              {resTabList.map((tb, ind) => (
                <button
                  key={ind}
                  type="button"
                  className={`pow-tab-btn${focusTab === ind ? " pow-active" : ""}`}
                  onClick={() => { setFocusTab(ind); setVideoPlaying(false); }}
                >
                  {tb.title}
                </button>
              ))}
            </div>

            {/* Announcements / Photos — highlight card driven by real gallery data */}
            {(focusTab === 0 || focusTab === 1) && (
              powHighlightImage ? (
                <div className="pow-highlight-card" onClick={() => setShowResModal(true)} style={{ cursor: "pointer" }}>
                  <div className="pow-highlight-thumb"><img src={powHighlightImage} alt="Highlight" loading="lazy" /></div>
                  <div>
                    <span className="pow-highlight-badge">Latest {resTabList[focusTab].title.toLowerCase()}</span>
                    <p className="pow-highlight-title">{resTabList[focusTab].title} from recent work</p>
                    <p className="pow-highlight-desc">{activeProofList.length} item{activeProofList.length !== 1 ? "s" : ""} in the gallery — tap to view.</p>
                  </div>
                </div>
              ) : (
                <p className="pow-empty">No {resTabList[focusTab].title.toLowerCase()} to show yet.</p>
              )
            )}

            {/* Video */}
            {focusTab === 2 && (
              state.serviceProviderVideo.length > 0 ? (
                <div className="pow-highlight-card" onClick={() => setShowResModal(true)} style={{ cursor: "pointer" }}>
                  <button
                    type="button"
                    className="pow-video-btn"
                    aria-label="Play intro video"
                    onClick={(e) => { e.stopPropagation(); setVideoPlaying(true); }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 21,12 5,21" /></svg>
                  </button>
                  <div>
                    <span className="pow-highlight-badge">Intro video</span>
                    <p className="pow-highlight-title">Watch a short introduction</p>
                    <p className="pow-highlight-desc">From {data.userDetails?.userName || data.eventDetails?.serviceName} — what to expect from a first session.</p>
                  </div>
                </div>
              ) : (
                <p className="pow-empty">No video to show yet.</p>
              )
            )}
            {focusTab === 2 && videoPlaying && state.serviceProviderVideo.length > 0 && (
              <div style={{ borderRadius: "14px", overflow: "hidden", marginBottom: "24px" }}>
                <video controls autoPlay style={{ width: "100%", display: "block" }}>
                  <source src={`${API_URL}auth/video/${state.serviceProviderVideo[0]}`} />
                </video>
              </div>
            )}

            {/* Reviews */}
            {focusTab === 3 && (
              data.reviewList?.length > 0 ? (
                <div className="pow-review-list">
                  {data.reviewList.slice(0, 2).map((item, ind) => (
                    <div key={ind} className="pow-review-card" onClick={() => setShowResModal(true)} style={{ cursor: "pointer" }}>
                      <Rating name="half-rating" value={item.satisfaction} size="small" precision={0.5} readOnly />
                      <p>{item.suggestion}</p>
                      <p style={{ fontWeight: 600 }}>{item.name} · {moment(new Date(item.updateDate)).format("DD MMM YYYY")}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="pow-empty">No reviews yet.</p>
              )
            )}

            <button type="button" className="pow-cta" onClick={() => setShowResModal(true)}>
              → View full portfolio
            </button>
          </div>
        </div>
      </section>

      {/* ── Profile detail section ── */}
      <section className="sp-pad">
        <div className="sp-wrap sp-profile" style={{ pointerEvents: isPreview ? "none" : "all" }}>
          <div>
            <div className="sp-avatar">
              <img src={businessLogo} alt="user" />
            </div>
          </div>

          <div className="sp-profile-body">
            <h3>{data.eventDetails?.serviceName}</h3>
            <span className="sp-role">{data.userDetails?.userName}</span>
            <p dangerouslySetInnerHTML={{ __html: data.eventDetails?.description }}></p>
            <div className="sp-badge-row">
              <span className="sp-badge" onClick={handleOpenReviews} style={{ cursor: "pointer" }}>
                ★ {data.eventDetails?.ratings ?? "4.1"} rating
              </span>
              <span className="sp-badge">{data.eventDetails?.noOfClients}+ clients</span>
              {data?.bookingCount > 9 && <span className="sp-badge">{data.bookingCount}+ bookings</span>}
            </div>
          </div>

          <div className="sp-contact-card">
            <button type="button" className="sp-btn sp-btn-dark" onClick={onSendMsgClick}>
              ✉ Send message
            </button>
            <button
              type="button"
              className="sp-btn sp-btn-primary"
              onClick={() => { setShowResModal(true); scrollToRef(proofSectionRef); }}
            >
              ▶ View portfolio
            </button>
            <hr className="sp-rule" style={{ margin: "16px 0" }} />
            {data.userDetails?.personalWebsite && (
              <button type="button" className="sp-website-link" onClick={() => window.open(data.userDetails?.personalWebsite, "_blank")}>
                🌐 Visit website
              </button>
            )}
            {data.socialMedia?.length > 0 && (
              <div className="sp-social-row">
                {data.socialMedia.map((item, i) => (
                  <a key={i} href={item.link} target="_blank" rel="noopener noreferrer">
                    <img src={item.icon} alt={item.platform} style={{ width: "16px", height: "16px", objectFit: "contain" }} />
                  </a>
                ))}
              </div>
            )}
            {data?.userDetails?.vcardUiid && (
              <div className="sp-qr-block">
                <img src={`${API_URL}auth/v2/qrcode/image?url=${BASE_URL}userProfile/${data.userDetails.vcardUiid}`} alt="quick contact QR" />
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ── Services ── */}
      <section className="sp-pad" ref={servicesSectionRef} id="services" style={{ background: "var(--muted)" }}>
        <div className="sp-wrap">
          <div className="sp-sec-head">
            <span className="sp-kicker">What's on offer</span>
            <h2>Schedule your session</h2>
            <p>Choose your preferred service, date, and time slot below.</p>
          </div>

          {data?.serviceList?.length > 0 && (
            <>
              <p className="sp-swipe-hint sp-services-hint">← swipe →</p>
              <div className="sp-scroll-indicator sp-services-indicator">
                <div className="sp-scroll-track"><div className="sp-scroll-fill" style={{ width: `${Math.max(6, servicesScrollPct)}%` }}></div></div>
                <span className="sp-scroll-count">{data.serviceList.length} services</span>
              </div>

              <div ref={servicesTrackRef} className="sp-service-grid" onScroll={trackScroll(servicesTrackRef, setServicesScrollPct)}>
                {data.serviceList.map((item, ind) => (
                  <div
                    key={ind}
                    className={`sp-service-card${chosenService === ind ? " sp-selected" : ""}`}
                    onClick={() => {
                      selectService(item);
                      setChosenService(ind);
                      setIsPackageSelected(item);
                      updateState("bookingMode", "self");
                      updateState("expertNote", "");
                      scrollToRef(bookSectionRef);
                    }}
                  >
                    {item.isRecurring === true && <span className="sp-tag">{item.packagePeriod}</span>}
                    <div className="sp-service-icon" style={{ background: `linear-gradient(60deg, ${getThemeItem(item.iconId).primary} 0%, ${getThemeItem(item.iconId).accent} 100%)` }}>
                      {typeof item.iconId === "number" && serviceIcons[item.iconId] ? serviceIcons[item.iconId].icon  : <img src={item?.img ? `${API_URL}auth/image/${item.img}` : businessLogo} alt="img" />}
                    </div>
                    <h4>{item.serviceName}</h4>
                    <p className="sp-desc">{item.description}</p>
                    <div className="sp-price-row">
                      <span className="sp-price">{priceLabel(item)}</span>
                      <span>· {item.duration} min</span>
                    </div>
                    {item.features?.length && (
                      <ul>
                        {item.features.split(",").map((feat, fi) => (
                          <li key={fi}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path>
                            </svg>
                            {feat}
                          </li>
                        ))}
                      </ul>
                    )}
                    <button
                      type="button"
                      className="sp-btn sp-btn-dark"
                      onClick={(e) => {
                        e.stopPropagation();
                        selectService(item);
                        setChosenService(ind);
                        setIsPackageSelected(item);
                        updateState("bookingMode", "self");
                        updateState("expertNote", "");
                        scrollToRef(bookSectionRef);
                      }}
                    >
                      Book now
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* ── Resources — direct-buy items, no calendar/slot flow.
          Reuses the same sp-service-card/sp-service-grid visual language
          as Services above for consistency, just with a "Resource" tag
          and a file-count line instead of duration. Only rendered when
          resources actually exist. ── */}
      {resourceList.length > 0 && (
        <section className="sp-pad" ref={resourcesSectionRef} id="resources">
          <div className="sp-wrap">
            <div className="sp-sec-head">
              <span className="sp-kicker">Ready-made resources</span>
              <h2>Get instant access</h2>
              <p>Downloadable resources you can grab right away — no scheduling needed.</p>
            </div>

            <div className="sp-service-grid">
              {resourceList.map((res) => {
                const isFree = Number(res.amount) === 0;
                const fileCount = res.resourceFileNames?.length || 0;
                return (
                  <div
                    key={res.id}
                    className="sp-service-card"
                    onClick={() => handleResourceCardClick(res)}
                  >
                    <span className="sp-tag">Resource</span>
                    <div
                      className="sp-service-icon"
                      style={{ background: `linear-gradient(60deg, ${getThemeItem(res.iconId).primary} 0%, ${getThemeItem(res.iconId).accent} 100%)` }}
                    >
                      {res.serviceImagePath
                        ? <img src={`${API_URL}auth/image/${res.serviceImagePath}`} alt="img" />
                        : <FiFileText size={20} color="#fff" />}
                    </div>
                    <h4>{res.serviceName}</h4>
                    <p className="sp-desc">{res.description}</p>
                    <div className="sp-price-row">
                      <span className="sp-price">{isFree ? "Free" : `₹${res.amount}`}</span>
                      {fileCount > 0 && (
                        <span>· {fileCount} file{fileCount !== 1 ? "s" : ""}</span>
                      )}
                    </div>
                    <button
                      type="button"
                      className="sp-btn sp-btn-dark"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleResourceCardClick(res);
                      }}
                    >
                      {isFree ? (
                        <>Get this resource <FiDownload size={15} style={{ marginLeft: 6 }} /></>
                      ) : (
                        <>Buy now <FiChevronRight size={15} style={{ marginLeft: 6 }} /></>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* ── Booking ── */}
      <section className="sp-pad" ref={bookSectionRef} id="book">
        <div className="sp-wrap">
          <div className="sp-sec-head">
            <span className="sp-kicker">Schedule your session</span>
            <h2>Pick a date and time that works for you</h2>
            <p>
              {data.eventDetails?.timeZone
                ? `All times shown in ${data.eventDetails.timeZone}.`
                : "All times shown in Asia/Kolkata."} You'll get instant confirmation the moment you book.
            </p>
          </div>

          <div
            className="serviceBookingPanel sp-book-panel"
            ref={scheduleRef}
            style={{ display: chosenService !== null ? "grid" : "none" }}
          >
            {/* Sidebar */}
            <div className="bookingServiceDetail">
              <span>
                <div style={{ background: `linear-gradient(60deg, ${getThemeItem(data.serviceList?.[chosenService]?.iconId).primary} 0%, ${getThemeItem(data.serviceList?.[chosenService]?.iconId).accent} 100%)` }}>
                  {typeof data.serviceList?.[chosenService]?.iconId === "number"
                    ? serviceIcons[data.serviceList?.[chosenService]?.iconId || 0].icon
                    : <img src={data.serviceList?.[chosenService]?.img ? `${API_URL}auth/image/${data.serviceList[chosenService].img}` : businessLogo} alt="img" />}
                </div>
                <div>
                  <h3>{data.serviceList?.[chosenService]?.serviceName || ""}</h3>
                  <p>{data.serviceList?.[chosenService]?.description || ""}</p>
                </div>
              </span>
              <span>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  Duration
                </div>
                <div>{data.serviceList?.[chosenService]?.duration || "100"} min</div>
              </span>
              <span>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--primary, hsl(340 82% 52%))" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                  </svg>
                  Price
                </div>
                <div>{priceLabel(data.serviceList?.[chosenService])}</div>
              </span>
              {data.eventDetails?.timeZone && (
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path>
                  </svg>
                  {data.eventDetails?.timeZone}
                </span>
              )}

              {/* ── Live "your booking so far" summary — purely derived from existing state ── */}
              {!data.detailsPage && (
                <div className="sp-summary-card" style={{ margin: "0 1.5rem 1.5rem" }}>
                  <h5>Your booking so far</h5>
                  <div className="sp-summary-row">
                    <span>Service</span>
                    <span>{selectedServiceObj?.serviceName || "Not selected"}</span>
                  </div>
                  <div className="sp-summary-row">
                    <span>Date</span>
                    <span>{data.activeIndexData?.value ? moment(data.activeIndexData.value, "YYYY/MM/DD").format("D MMM YYYY") : "Not selected"}</span>
                  </div>
                  <div className="sp-summary-row">
                    <span>Time</span>
                    <span>{data.selectedSlot ? `${data.selectedSlot.from} – ${data.selectedSlot.to}` : "Not selected"}</span>
                  </div>
                </div>
              )}
            </div>

            {/* Schedule panel */}
            <div className="schedulePanel">
              <section className="serviceBookingSec">
                {data.detailsPage ? (
                  /* ════ STEP 2: Details Form ════ */
                  <form
                    onSubmit={uploadDetails}
                    className="w-100 p-3 d-flex flex-column font-weight-bold slotBookingForm"
                    style={{ fontSize: "12px", maxWidth: "95%" }}
                  >
                    {renderStepper(2)}

                    <h5 className="font-weight-bold d-flex align-items-center" style={{ marginTop: "1rem" }}>
                      <IoArrowBackCircleOutline
                        style={{ fontSize: "2rem", marginInlineEnd: "10px" }}
                        onClick={() => { recaptcha?.current?.reset(); updateState("detailsPage", false); }}
                      />
                      Enter your details for further communication ..
                    </h5>
                    <label className="mt-2">Name *</label>
                    <input
                      style={{ caretColor: "black" }}
                      className="input-text-input text-dark"
                      value={data.name}
                      type="text"
                      placeholder="Enter name"
                      required
                      onChange={(e) => updateState("name", e.target.value)}
                    />
                    <label className="mt-2">Email *</label>
                    <input
                      style={{ caretColor: "black" }}
                      className="input-text-input text-dark"
                      value={data.email}
                      type="email"
                      placeholder="Enter email"
                      required
                      onChange={(e) => updateState("email", e.target.value?.trim())}
                    />
                    <label className="mt-2">Phone Number *</label>
                   <PhoneInput
        country={"in"}
        containerClass="input-dark"
        value={state.phoneNumber}
        placeholder=""
        countryCodeEditable={false}
        onChange={(phone) => updateState("phoneNumber", phone)}
        required
      />

                    
                    <label className="mt-2">Please share anything that will help prepare for our meeting *</label>
                    <textarea
                      style={{ caretColor: "black", minHeight: "5rem" }}
                      className="input-text-input text-dark p-2"
                      value={data.description}
                      type="text"
                      required
                      onChange={(e) => updateState("description", e.target.value)}
                    />
                    <div style={{ marginTop: "2rem", marginBottom: "1rem" }}>
                      <ReCAPTCHA
                        size={isMobile ? "compact" : "normal"}
                        ref={recaptcha}
                        sitekey={REACT_APP_SITE_KEY}
                      />
                    </div>
                    <button type="submit" className="scheduleBt" onClick={() => confirmDetails()}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path>
                      </svg>
                      {`Book ${data.serviceList?.[chosenService]?.serviceName} - ${priceLabel(data.serviceList?.[chosenService])}`}
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path>
                      </svg>
                    </button>
                  </form>
                ) : (
                  /* ════ STEP 1: Slot choosing ════ */
                  <div className="slotChoseingParent">
                    {["group_package", "one_to_one_package"].includes(isPackageSelected?.appointmentName) ? (
                      /* ════ GROUP / PACKAGE BOOKING ════ */
                      <>
                        <div className="scheduleHeader">
                          <h2>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--primary, #161616)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M8 2v4" /><path d="M16 2v4" /><rect width="18" height="18" x="3" y="4" rx="2" /><path d="M3 10h18" />
                            </svg>
                            Group Package Schedule
                          </h2>
                          <p>This package runs on a <b>{isPackageSelected.packagePeriod}</b> basis.</p>
                        </div>
                        <div className="calTimeSplit" style={{ margin: "20px 20px 0" }}>
                          <div className="calSide">
                            <div className="panelLabel">{calIconSvg} Select Date</div>
                            <MonthGridCalendar
                              slots={data.slots}
                              packageDays={packageDays}
                              selectedValue={data.activeIndexData?.value}
                              hoverCol={hoverCol}
                              onSelect={(slotObj) => {
                                const idx = data.slots?.findIndex(s => s.value === slotObj.value);
                                viewAvailableSlot(idx ?? 0, slotObj, slotObj.available);
                              }}
                            />
                          </div>
                          <TimeSidePanel
                            hasDateSelected={!!data.activeIndexData?.value}
                            slots={timeSlots}
                            selectedSlot={data.selectedSlot}
                            hoverCol={hoverCol}
                            onSelect={(item) => updateState("selectedSlot", item)}
                            isDisabledFn={() => false}
                          />
                        </div>
                      </>
                    ) : (
                      /* ════ INDIVIDUAL BOOKING ════ */
                      <>
                        {renderStepper(1)}

                        <div style={{ padding: "1rem 1.25rem .25rem" }}>
                          <div className="scheduleHeader" style={{ marginBottom: ".5rem" }}>
                            <h2>
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--primary, #161616)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path>
                              </svg>
                              Schedule your session
                            </h2>
                            <p>Choose how you'd like to book</p>
                          </div>

                          {/* ── Booking mode toggle — reads/writes data.bookingMode via updateState ── */}
                          {/* ── Booking mode toggle — reads/writes data.bookingMode via updateState ── */}
<div className="bkModeRow">
  <div
    className={`bkModeCard${data.bookingMode === "self" ? " bkSelected" : ""}`}
    onClick={() => updateState("bookingMode", "self")}
  >
    <div className="bkModeRadio">
      {data.bookingMode === "self" && <div className="bkModeRadioInner" />}
    </div>
    <div className="bkModeText">
      <h5>I'll pick date &amp; time</h5>
      <p>Select from available slots</p>
    </div>
  </div>

  <div
    className={`bkModeCard${data.bookingMode === "expert" ? " bkSelected" : ""}`}
    onClick={() => updateState("bookingMode", "expert")}
  >
    <div className="bkModeRadio">
      {data.bookingMode === "expert" && <div className="bkModeRadioInner" />}
    </div>
    <div className="bkModeText">
      <h5>Let the expert choose</h5>
      <p>Share your preference and expert will schedule</p>
    </div>
  </div>
</div>

{/* ── Expert note — only shown when expert mode active ── */}
{data.bookingMode === "expert" && (
  <div className="expertNoteWrap">
    <label>Share your preference / availability</label>
    <textarea
      placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
      value={data.expertNote || ""}
      onChange={(e) => updateState("expertNote", e.target.value)}
    />
    <p className="expertHint">
      The expert will review your preference and send you a confirmed slot via email.
    </p>
  </div>
)}

             
                        </div>

                        {/* ── Calendar + time slots — ONLY shown when self mode ── */}
                        {data.bookingMode === "self" && (
                          <div className="calTimeSplit" style={{ margin: "0 20px" }}>
                            <div className="calSide">
                              <div className="panelLabel">{calIconSvg} Select Date</div>
                              <MonthGridCalendar
                                slots={data.slots}
                                packageDays={[]}
                                selectedValue={data.activeIndexData?.value}
                                hoverCol={hoverCol}
                                onSelect={(slotObj) => {
                                  const idx = data.slots?.findIndex(s => s.value === slotObj.value);
                                  viewAvailableSlot(idx ?? 0, slotObj, slotObj.available);
                                }}
                              />
                            </div>

                            <div className="timeSide">
                              <div className="panelLabel">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                  <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                                </svg>
                                Available Time Slots
                              </div>

                              {data.activeIndexData?.value && (
                                <div className="tzChip">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                                  </svg>
                                  {data.eventDetails?.timeZone
                                    ? `All times shown in ${data.eventDetails.timeZone}`
                                    : "All times shown in Asia/Kolkata (IST)"}
                                </div>
                              )}

                              {!data.activeIndexData?.value ? (
                                <div className="calEmptyState">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#c4c9d8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                                  </svg>
                                  <p>
                                    <strong>No date selected</strong>
                                    Pick a date on the left to see available time slots
                                  </p>
                                </div>
                              ) : (
                                <div className="twoColSlots slotPanel">
                                  {getAllSlots().length > 0
                                    ? getAllSlots().map((item, i) => {
                                        const fromStr = item.from ?? "";
                                        const toStr = item.to ?? "";
                                        const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
                                        const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
                                        const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
                                        const isSelected = data.selectedSlot?.from === fromStr && data.selectedSlot?.to === toStr;
                                        const isDisabled = item.slotAvailable === false;
                                        return (
                                          <button
                                            key={i}
                                            className={`timeSlotBtn${isSelected ? " tsActive" : ""}${isDisabled ? " tsDisabled" : ""}`}
                                            style={isSelected ? { background: hoverCol } : {}}
                                            onClick={() => {
                                              if (!isDisabled) {
                                                updateState("slotActiveIndex", i);
                                                updateState("selectedSlot", item);
                                              }
                                            }}
                                          >
                                            {displayFrom} – {displayTo}
                                          </button>
                                        );
                                      })
                                    : <p className="noTimeMsg" style={{ gridColumn: "1/-1" }}>No slots available for this date</p>
                                  }
                                </div>
                              )}

                              <div className="sp-confirm-box instantBadge">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--accent, #d97706)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: "2px" }}>
                                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                                </svg>
                                <div>
                                  <h6>Instant confirmation</h6>
                                  <p>Your session will be confirmed immediately after booking.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </section>

              {!data.detailsPage && (
                <>
                  <button
                    className="scheduleBt"
                    onClick={() => (isPreview ? () => {} : confirmDetails())}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path>
                    </svg>
                    {`Book ${data.serviceList?.[chosenService]?.serviceName} - ${priceLabel(data.serviceList?.[chosenService])}`}
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>
                  <div className="secureFooter">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--desText, #999)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    </svg>
                    Secure Payment &nbsp;•&nbsp; 100% Safe &amp; Trusted
                  </div>
                </>
              )}
            </div>
          </div>

          {chosenService === null && (
            <p style={{ color: "var(--desText)", fontFamily: "var(--fontMono)", fontSize: "13px" }}>
              Choose a service above to see available dates and times.
            </p>
          )}
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="sp-footer" ref={footerSectionRef} id="contact">
        <div className="sp-wrap">
          <div className="sp-foot-grid">
            <div>
              <div className="sp-brand sp-foot-brand">
                <span className="sp-mark"><img src={businessLogo} alt="logo" /></span>
                {data.eventDetails?.serviceName || data.userDetails?.userName || "My Business"}
              </div>
              <p className="sp-foot-desc" dangerouslySetInnerHTML={{ __html: data.eventDetails?.description }}></p>
            </div>
            <div>
              <h5>Navigate</h5>
              <button type="button" className="sp-foot-link" onClick={() => scrollToRef(servicesSectionRef)}>Services</button>
              <button type="button" className="sp-foot-link" onClick={() => scrollToRef(bookSectionRef)}>Book a session</button>
              <button type="button" className="sp-foot-link" onClick={() => scrollToRef(proofSectionRef)}>Proof of work</button>
            </div>
            <div>
              <h5>Quick contact</h5>
              <button type="button" className="sp-foot-link" onClick={onSendMsgClick}>✉ Send a message</button>
              {data.userDetails?.personalWebsite && (
                <button type="button" className="sp-foot-link" onClick={() => window.open(data.userDetails?.personalWebsite, "_blank")}>🌐 Visit website</button>
              )}
              {data?.userDetails?.vcardUiid && (
                <div className="sp-qr-block">
                  <img src={`${API_URL}auth/v2/qrcode/image?url=${BASE_URL}userProfile/${data.userDetails.vcardUiid}`} alt="quick contact QR" />
                </div>
              )}
            </div>
          </div>
          <div className="sp-foot-bottom">
            <span>© {new Date().getFullYear()} {data.eventDetails?.serviceName || data.userDetails?.userName || "My Business"}</span>
            <span>{data.eventDetails?.ratings ?? "4.1"} ★ average · {data.eventDetails?.noOfClients || 0}+ clients advised</span>
          </div>
        </div>
      </footer>

      {/* ── Full portfolio modal — driven by showResModal, reuses focusTab/resTabList
          so the tab you clicked from opens already selected. Shows ALL items
          (all images, full review list), not just the highlight card. ── */}
      {showResModal && (
        <div className="pow-modal-overlay" onClick={() => setShowResModal(false)}>
          <style>{`
            .pow-modal-overlay { position: fixed; inset: 0; background: rgba(15,20,15,.65); z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 24px; }
            .pow-modal { background: var(--card, #fff); color: var(--card-foreground, #222); width: 100%; max-width: 920px; max-height: 85vh; border-radius: 20px; overflow: hidden; display: flex; flex-direction: column; box-shadow: 0 30px 60px rgba(0,0,0,.4); }
            .pow-modal-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 18px 22px; border-bottom: 1px solid var(--border, #eee); flex-wrap: wrap; }
            .pow-modal-tabs { display: flex; flex-wrap: wrap; gap: 8px; }
            .pow-modal-tab-btn { border: 1px solid var(--border, #ddd); background: var(--card, #fff); color: var(--card-foreground, #333); padding: 8px 16px; border-radius: 999px; font-size: 13px; cursor: pointer; }
            .pow-modal-tab-btn.pow-modal-tab-active { background: var(--primary, #17281d); color: #fff; border-color: var(--primary, #17281d); font-weight: 600; }
            .pow-modal-close { border: none; background: var(--thinBg, #f2f2f2); width: 34px; height: 34px; border-radius: 50%; font-size: 15px; cursor: pointer; flex-shrink: 0; }
            .pow-modal-body { padding: 22px; overflow-y: auto; }
            .pow-modal-count { font-size: 12.5px; color: var(--desText, #888); margin: 0 0 14px; }
            .pow-modal-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 10px; }
            .pow-modal-tile { aspect-ratio: 1; border-radius: 10px; overflow: hidden; cursor: pointer; background: var(--thinBg, #f2f2f2); }
            .pow-modal-tile img { width: 100%; height: 100%; object-fit: cover; display: block; transition: transform .2s ease; }
            .pow-modal-tile:hover img { transform: scale(1.06); }
            .pow-modal-reviews { display: flex; flex-direction: column; gap: 14px; }
            .pow-modal-preview-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.85); z-index: 1100; display: flex; align-items: center; justify-content: center; padding: 30px; }
            .pow-modal-preview-overlay img { max-width: 100%; max-height: 100%; border-radius: 10px; display: block; }
            @media (max-width: 640px) {
              .pow-modal { max-height: 90vh; }
              .pow-modal-grid { grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); }
            }
          `}</style>

          <div className="pow-modal" onClick={(e) => e.stopPropagation()}>
            <div className="pow-modal-header">
              <div className="pow-modal-tabs">
                {resTabList.map((tb, ind) => (
                  <button
                    key={ind}
                    type="button"
                    className={`pow-modal-tab-btn${focusTab === ind ? " pow-modal-tab-active" : ""}`}
                    onClick={() => { setFocusTab(ind); setVideoPlaying(false); setChosenRes({ type: "", url: "" }); }}
                  >
                    {tb.title}
                  </button>
                ))}
              </div>
              <button type="button" className="pow-modal-close" aria-label="Close" onClick={() => setShowResModal(false)}>✕</button>
            </div>

            <div className="pow-modal-body">
              {(focusTab === 0 || focusTab === 1) && (
                activeProofList.length > 0 ? (
                  <>
                    <p className="pow-modal-count">{activeProofList.length} item{activeProofList.length !== 1 ? "s" : ""}</p>
                    <div className="pow-modal-grid">
                      {activeProofList.map((img, i) => (
                        <div key={i} className="pow-modal-tile" onClick={() => setChosenRes({ type: "image", url: img })}>
                          <img src={img} alt={`${resTabList[focusTab].title} ${i + 1}`} loading="lazy" />
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <p className="pow-empty" style={{ color: "var(--desText, #888)" }}>No {resTabList[focusTab].title.toLowerCase()} to show yet.</p>
                )
              )}

              {focusTab === 2 && (
                state.serviceProviderVideo.length > 0 ? (
                  <video controls autoPlay style={{ width: "100%", borderRadius: "14px", display: "block" }}>
                    <source src={`${API_URL}auth/video/${state.serviceProviderVideo[0]}`} />
                  </video>
                ) : (
                  <p className="pow-empty" style={{ color: "var(--desText, #888)" }}>No video to show yet.</p>
                )
              )}

              {focusTab === 3 && (
                data.reviewList?.length > 0 ? (
                  <div className="pow-modal-reviews">
                    <p className="pow-modal-count">{data.reviewList.length} review{data.reviewList.length !== 1 ? "s" : ""}</p>
                    {data.reviewList.map((item, ind) => (
                      <div key={ind} className="pow-review-card">
                        <Rating name="half-rating" value={item.satisfaction} size="small" precision={0.5} readOnly />
                        <p>{item.suggestion}</p>
                        <p style={{ fontWeight: 600 }}>{item.name} · {moment(new Date(item.updateDate)).format("DD MMM YYYY")}</p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="pow-empty" style={{ color: "var(--desText, #888)" }}>No reviews yet.</p>
                )
              )}
            </div>
          </div>

          {/* Enlarged single-image preview, on top of the modal */}
          {chosenRes.type === "image" && chosenRes.url && (
            <div className="pow-modal-preview-overlay" onClick={() => setChosenRes({ type: "", url: "" })}>
              <img src={chosenRes.url} alt="preview" loading="lazy" />
            </div>
          )}
        </div>
      )}

    </div>
  );
};

export default ServiceCardThemeV2;